import React,{useContext,useEffect, useState, useRef} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, StepForwardIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';

export default function DepartmentAdd({department,type="add"}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);


    const [formDepartment,setFormDepartment] = useState(department);
    const [departmentType, setDepartmentType] = useState(type);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [scrollIcons,setScrollIcons] = useState(true);

    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);
    const componentRef = useRef(null);

    useEffect(() => {
        // Update the document title using the browser API
        if(departmentType=="edit"){
            setScrollIcons(false);
        }
    },[departmentType]);

    /* validate form */
    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    /* form for adding error record */
    const formik = useFormik({
        initialValues: formDepartment==null?{
            name: '',hourly_rate:'',defined_id:'',
        }:formDepartment,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            if(departmentType=="add"){
                postRequest('/api/departments', formData,true)
                .then((response) => {
                    console.log(response);
                    getRequest("/api/departments").then((response) => {
                        dispatch({type:'load_departments',newDepartments:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setDepartmentType("edit");
                        toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
            else{
                postRequest(`/api/departments/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/departments").then((response) => {
                        dispatch({type:'load_departments',newDepartments:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        formik.setValues(values);
                        toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    alert(t('Common.Toast.ActionFailedDetail'));
                })
            }
        },
    });

      function copyDepartment(){
        dispatch({type:'create_new_tab',name: t('DepartmentList.Tab.New'), translationKey: 'DepartmentList.Tab.New', legacyLabel: t('DepartmentList.Tab.New'),page:'DepartmentAdd',props:{department: formik.values,type:'copy'},mask:'gset002'})
      }
      function addNewDepartment(){
        dispatch({type:'create_new_tab',name: t('DepartmentList.Tab.New'), translationKey: 'DepartmentList.Tab.New', legacyLabel: t('DepartmentList.Tab.New'),page:'DepartmentAdd',props:{department: null,type:'add'},mask:'gset002'})
      }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createArrayNavigateHandlers(state.departments, formik.values?.id, setFormDepartment);


return(
<>
<div>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => addNewDepartment()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => copyDepartment()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('DepartmentList.Tab.New'),"DepartmentAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("DepartmentAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
<div className="relative flex flex-col justify-left overflow-x min-h-[calc(100vh-177px)]">
    <div className=" mb-2 ">
    <form onSubmit={formik.handleSubmit}>
    <div className="w-auto p-6 m-4 bg-gray-100">
    <h1 className="text-3xl font-semibold text-left text-zinc-900">
        {t('DepartmentAdd.Title')}
    </h1>
    {departmentType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>}
    <div className="mb-2">
      <div>
        <label
            for="name"
            className="block text-md font-semibold text-gray-800"
        >
            {t('DepartmentList.Column.Name')}
        </label>
        <input
            name='name'
            type="text"
            onChange={formik.handleChange} value={formik.values.name}
            className="block w-fit  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
        />
        </div>
        <div>
        <label
            for="hourly_rate"
            className="block text-md font-semibold text-gray-800"
        >
            {t('DepartmentList.Column.HourlyRate')}
        </label>
        <input
            name='hourly_rate'
            type="text"
            onChange={formik.handleChange} value={formik.values.hourly_rate}
            className="block w-fit px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
        />
        </div>
    </div>
    <div className="mb-2">
      <div>
        <label
            for="defined_id"
            className="block text-md font-semibold text-gray-800"
        >
            {t('DepartmentList.Column.DefinedId')}
        </label>
        <input
            name='defined_id'
            type="text"
            onChange={formik.handleChange} value={formik.values.defined_id}
            className="block w-fit px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
        />
        </div>
        </div>
    
    </div>
    <button type="submit" ref={submitRef} className='hidden'></button>  
    </form>           
    </div>
    </div>
    </div>
    </>
    );
}